const t = (t2) => {
  const o = t2 == null ? void 0 : t2.status;
  if (o >= 500 && o < 600) throw t2;
};
export {
  t as throwServerError
};
//# sourceMappingURL=throwServerError.js.map
